import { environment } from "../../../environments/environment";

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/Authentication/Login',
  },
  PREMIX_CALCULATOR: {
    GET_PAGE_DATA: '/api/premixcalculator/getpagedata',
    SAVE_COMPANY: '/api/premixcalculator/savecompany',
    SAVE_PREMIX_DATA: '/api/premixcalculator/saveorupdatepremixdetails',
    GET_PREMIX_DATA: '/api/premixcalculator/getpremixdetails',
    DELETE_PREMIX: '/api/premixcalculator/deletepremixdetails',
    DELETE_ACTIVE_INGREDIENT: '/api/premixcalculator/deleteactiveingredient',
    SAVE_ACTIVE_INGREDIENT: '/api/premixcalculator/updatepremixdetailsai',
    SAVE_PRODUCT: '/api/premixcalculator/updatepremixdetailsproducts',
    GET_CALCULATOR_PAGE_DATA: '/api/premixcalculator/getpremixcalculatordetails',
    EXPORT_PDF: '/api/premixcalculator/exportpdf',
    EXPORT_PDF_ATS: '/api/premixcalculator/exportatspdf',
    EXPORT_PDF_JARMIX: '/api/premixcalculator/exportjarmixpdf',
    SAVE_LEGAL: '/api/premixcalculator/savepremixlegaltext',
    GET_LEGAL: '/api/premixcalculator/getpremixlegaltext',
  },
  TECHNICAL_GUIDE: {
    CHECK_FILE_STATUS: '/v1.0/media/checkfilestatus',
    CHECK_FILE_STATUS_S3: '/api/amazonS3FileUpload/IsFileExistsInS3Bucket',
    POST_PDF_FILE: '/api/amazonS3FileUpload/UploadFileToS3Bucket',
    INVALIDATE_IMAGE_S3: '/api/amazonS3FileUpload/InvalidateImageInS3Bucket',
    SAVE_TEMP_FILE: '/v1.0/media/entity/temp/saveorupdate',
    ENTITY_CONTENT: '/v1.0/media/entity/insert',
    ASSOCIATION_LIST: '/v1.0/media/entity/association/insert',
    DELETE_DOCUMENT: '/api/amazonS3FileUpload/DeleteFileFromS3Bucket',
    DELETE_MEDIA: '/v1.0/media/delete',
    SAVE_TECH_GUIDE_DATA: '/api/premixcalculator/saveorupdatetechnicalguidedetails',
    GET_TECH_GUIDE_DATA: '/api/premixcalculator/gettechguidepagedata',
    GET_TECH_GUIDE: '/api/premixcalculator/GetTechnicalGuideDetailsById',
    ACTIVE_DEACTIVE_TECH_GUIDE: '/api/premixcalculator/activatedeactivatetechnicalguidedetails',
    DELETE_TECH_GUIDE: '/api/premixcalculator/deletetechnicalguidedetails',
    GET_TECHNICAL_GUIDE_PAGE_DATA: '/api/premixcalculator/gettechnicalguidedetails',
  },
  RESISTANCE_MANAGEMENT: {
    GET_RATING: '/api/resistancemanagement/getresistancemanagementrating',
    SAVE_PRODUCT: '/api/resistancemanagement/saveproduct',
    UPDATE_PRODUCT: '/api/resistancemanagement/updateproduct',
    DELETE_PRODUCT: '/api/resistancemanagement/deleteproduct',
    EXPORT_PROGRAM_BUILDER_PDF: '/api/resistancemanagement/exportprogrambuilderpdf',
    EXPORT_RESISTANCE_MANAGEMENT_PDF: '/api/resistancemanagement/exportresistancemanagementpdf',
    DUMMY_IMAGE_URL:'https://placehold.co/600x200/transparent/svg?text='
  }
};

// Helper function to build complete API URLs
export const buildApiUrl = (endpoint: string): string => {
  return environment.api.cmsUrl + endpoint;
};
